import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { CoreService, HttpService } from '../services';
import { eAppContext, QueovalBase, Alert } from '../models/global/class.global';
import {  AlertCode } from '../models/global/enum.global';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SignatureModel } from '../models/signature/signature.model';
import { ToastService } from '../toast';
import { Router } from '@angular/router';
import { setAlertMNG } from '../utilities';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.css'],
})

export class SignatureComponent implements OnInit {

  private started: boolean = false;
  public mouseDown: boolean = false;
  private context: any = null;
  private canvas: any = null;
  public preview: string | ArrayBuffer | null = null;
  public pathExistButUnfounded: boolean = false;
  public loaded: boolean = false;

  public inputHeight: number | null = null;
  public height: number = 150;
  public isPercentHeight: boolean = false;

  private fixedHeight: number = 150;
  private fixedWidth: number = 300;

  public inputWidth: number | null = null;
  public width: number = 300;
  public isPercentWidth: boolean = false;

  private maxTop: number = -1;
  private maxBottom: number = -1;
  private maxRight: number = -1;
  private maxLeft: number = -1;
  private lastX: number = -1;
  private lastY: number = -1;

  public autoSave: boolean = false;

  public isEditable: boolean = false;

  public border: number = 6;

  public drawnLine: boolean = false;
  public mode: string = "CONTACT_RESERV"
  public signatureDisabled: boolean = false;

  @Input('height')
  set Height(value: string) {
    if (value.includes('px')) {
      const _h = parseInt(value.replace('px', ''));
      this.height = _h > this.fixedHeight ? this.fixedHeight : _h;
    } else if (value.includes('%')) {
      this.isPercentHeight = true;
      this.inputHeight = parseInt(value.replace('%', ''));
      this.calculHeightSize(this.inputHeight);
    }
  }

  @Input('width')
  set Width(value: string) {
    if (value.includes('px')) {
      const _w = parseInt(value.replace('px', ''))
      this.width = _w > this.fixedWidth ? this.fixedWidth : _w;
    } else if (value.includes('%')) {
      this.isPercentWidth = true;
      this.inputWidth = parseInt(value.replace('%', ''));
      this.calculWidthSize(this.inputWidth);
    }
  }
  @Input('signatureDisabled') set SetSignatureDisabled(value: boolean | string) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.signatureDisabled = true;
    } else {
      this.signatureDisabled = value;
    }
  }

  @Input('idPere') idPere: string;
  @Input('idFils') idFils: string;
  @Input('nomRel') nomRel: string;
  @Input('Editable')
  set Editable(value: boolean) {
    this.isEditable = value;
  }

  @Input('mode')
  set Mode(value: string) {
    this.mode = value;
  }

  @Input('save')
  set AutoSave(value: boolean) {
    this.autoSave = true;
    if (value) {
      this.Save();
      this.saveEmitter.emit(false);
    }

  }

  @HostListener('window:resize', ['$event'])
  OnResizing(e: any) {
    if (this.inputHeight !== null) {
      this.calculHeightSize(this.inputHeight);
    }
    if (this.inputWidth !== null) {
      this.calculWidthSize(this.inputWidth);
    }
  }

  @Output('saveChange') saveEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output('blockingRelation') blockingRelation: EventEmitter<string> = new EventEmitter<string>();
  @Output('fileExist') fileExistEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  // #region CONSTRUCTEUR
  constructor(
    private sanitize: DomSanitizer,
    private indParam: CoreService,
    private http: HttpClient,
    private httpservice: HttpService,
    private toast: ToastService,
    private router: Router) { }
  // #endregion

  // #region CYCLE DE VIE

  ngOnInit(): void {
    if (this.idPere && this.idFils && this.nomRel) {
      this.httpservice.getHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/GET_SIGNATURE_${this.mode}/${this.idPere}|${this.idFils}|${this.nomRel}`).subscribe(
        (result: SignatureModel) => {
          this.preview = result.strPath;
          this.pathExistButUnfounded = result.pathExistButUnfounded;
          this.fileExistEmitter.emit(!!this.preview);
          if (result.strRelationBloquante) {
            this.blockingRelation.emit(result.strRelationBloquante);
          }
          this.loaded = true;
        });
    }
  }

  public StyleSanitized(value: number): SafeStyle {
    return this.sanitize.bypassSecurityTrustStyle(!this.preview ? `${value}px` : 'auto');
  }

  public calculHeightSize(percent: number) {
    setTimeout(() => {
      const signatureContainer = document.getElementById('SignatureContainer')
      if (signatureContainer !== null) {
        if (this.isPercentHeight) {
          const parentElem: any = signatureContainer.parentElement
          if (parentElem) {
            const parentHeight = parentElem.parentElement.clientHeight
            const _h = parentHeight === null || parentHeight === undefined || parentHeight === 0 ? this.height : parentHeight * percent / 100;
            this.height = _h > this.fixedHeight ? this.fixedHeight : _h;
          }
        }
      }
    }, 0);
  }

  public calculWidthSize(percent: number) {
    setTimeout(() => {
      const signatureContainer = document.getElementById('SignatureContainer')
      if (signatureContainer !== null) {
        if (this.isPercentWidth) {
          const parentElem: any = signatureContainer.parentElement
          if (parentElem) {
            const parentWidth = parentElem.parentElement.clientWidth
            const _w = parentWidth === null || parentWidth === undefined || parentWidth === 0 ? this.width : parentWidth * percent / 100;
            this.width = _w > this.fixedWidth ? this.fixedWidth : _w;
          }
        }
      }
    }, 0);
  }

  public OnTouchStart(e: any): void {
    this.OnMousedown(e);
  }

  public OnMousedown(e: any): void {
    if (e.target.tagName === 'CANVAS') {
      this.canvas = e.target;
      this.canvas.addEventListener("touchstart", function (event: any) { event.preventDefault() });
      this.canvas.addEventListener("touchmove", function (event: any) { event.preventDefault() });
      this.canvas.addEventListener("touchend", function (event: any) { event.preventDefault() });
      this.canvas.addEventListener("touchcancel", function (event: any) { event.preventDefault() });

      this.context = e.target.getContext('2d');
      this.context.beginPath();

      var layerX: number = e.pageX ? e.pageX - e.target.getBoundingClientRect().left : e.layerX ? e.layerX : e.targetTouches[0].pageX - e.target.getBoundingClientRect().left;
      var layerY: number = e.pageY ? e.pageY - e.target.getBoundingClientRect().top : e.layerY ? e.layerY : e.targetTouches[0].pageY - e.target.getBoundingClientRect().top;

      this.lastX = layerX;
      this.lastY = layerY;
      this.context.moveTo(layerX, layerY);
      this.started = true;
    }
  }

  public OnTouchEnd(e: any): void {
    this.Onmouseup(e);
  }
  public Onmouseup(e: any): void {
    if (this.started) {
      this.OnMouseMove(e);
      this.started = false;
    }
  }

  public OnMouseMove(e: any): void {
    if (this.started) {
      if (e.offsetX || e.touches.length > 0) {
        const offsetX: number = e.offsetX ? e.offsetX : e.targetTouches[0].pageX - e.target.getBoundingClientRect().left;
        const offsetY: number = e.offsetY ? e.offsetY : e.targetTouches[0].pageY - e.target.getBoundingClientRect().top;

        const currentX: number = offsetX > 0 ? offsetX : this.width - offsetX;
        const currentY: number = offsetY > 0 ? offsetY : this.height - offsetY;
        if (currentX < this.maxLeft || this.maxLeft == -1) {
          this.maxLeft = currentX;
        }
        if (currentX > this.maxRight || this.maxRight == -1) {
          this.maxRight = currentX;
        }
        if (currentY < this.maxTop || this.maxTop == -1) {
          this.maxTop = currentY;
        }
        if (currentY > this.maxBottom || this.maxBottom == -1) {
          this.maxBottom = currentY;
        }

        var layerX: number = e.pageX ? e.pageX - e.target.getBoundingClientRect().left : e.layerX ? e.layerX : e.targetTouches[0].pageX - e.target.getBoundingClientRect().left;
        var layerY: number = e.pageY ? e.pageY - e.target.getBoundingClientRect().top : e.layerY ? e.layerY : e.targetTouches[0].pageY - e.target.getBoundingClientRect().top;

             
        this.context.lineTo(layerX, layerY);
        this.context.stroke();
        if (this.lastX > layerX + 10 || layerX > this.lastX + 10 || this.lastY > layerY + 10 || layerY > this.lastY + 10) {
          this.drawnLine = true;
        }
      }
    }
  }

  public Clear(): void {
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.maxTop = -1;
    this.maxBottom = -1
    this.maxRight = -1;
    this.maxLeft = -1;
    this.drawnLine = false;
  }

  public Update(): void {
    const image = document.getElementById("signatureImage");
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    if (image) {
      const destCoordonneeX = this.canvas.width - this.fixedWidth > 0 ? (this.canvas.width - this.fixedWidth) / 2 : 0;
      const destCoordonneeY = this.canvas.height - this.fixedHeight > 0 ? (this.canvas.height - this.fixedHeight) / 2 : 0;

      this.context.drawImage(
        image,
        0, 0, this.fixedWidth, this.fixedHeight, //srctWidth + (destCoordonneeX * 2) + this.border, srctHeight + (destCoordonneeY * 2) + this.border,
        destCoordonneeX, destCoordonneeY, this.fixedWidth, this.fixedHeight); //this.width + this.border, this.height + this.border);
      this.maxBottom = destCoordonneeY + this.fixedHeight;
      this.maxTop = destCoordonneeY;
      this.maxLeft = destCoordonneeX;
      this.maxRight = destCoordonneeX + this.fixedWidth;
      this.preview = null;
    }
  }

  public Save(): void {
    if (this.drawnLine) {
      //const resizedCanvas = document.createElement("canvas");
      //const resizedContext = resizedCanvas.getContext("2d");
      //resizedCanvas.height = this.fixedHeight; //this.maxBottom - this.maxTop + this.border;
      //resizedCanvas.width = this.fixedWidth; //this.maxRight - this.maxLeft + this.border;
      //if (resizedContext !== null) {
      //  const sHeight: number = this.height - this.maxTop - (this.height - this.maxBottom);
      //  const sWidth: number = this.width - this.maxLeft - (this.width - this.maxRight);

      //  let dHeight: number = sHeight;
      //  let dWidth: number = sWidth;

      //  if (dHeight > this.fixedHeight || dWidth > this.fixedWidth) {
      //    if (dHeight > dWidth) {
      //      dHeight = this.fixedHeight;
      //      dWidth = sWidth * this.fixedWidth / sHeight;

      //    }
      //    else {
      //      dHeight = sHeight * this.fixedHeight / sWidth;
      //      dWidth = this.fixedWidth;
      //    }
      //  }

      //  resizedContext.drawImage
      //    (
      //      // image
      //      this.canvas,
      //      // coordonnée x, coordonnée y, largeur, hauteur de la redimensions de la sources
      //      this.maxLeft - (this.border / 2), this.maxTop - (this.border / 2), sWidth + this.border, sHeight + this.border,
      //      //coordonnée x, coordonnée y, largeur, hauteur de l'image de destination
      //      (this.fixedWidth - dWidth - this.border) / 2, (this.fixedHeight - dHeight - this.border) / 2, dWidth + this.border, dHeight + this.border //this.maxRight - this.maxLeft + this.border, this.maxBottom - this.maxTop + this.border
      //    );

      // const binStr: string = atob(resizedCanvas.toDataURL().split(',')[1]),
      const binStr: string = atob(this.canvas.toDataURL().split(',')[1]),
          len = binStr.length,
          arr = new Uint8Array(len);

        for (var i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }
        const blob = new Blob([arr]);
        var file: File = new File([blob], 'signature', { type: 'image/jpg' });

        const reader: FileReader = new FileReader();
        reader.readAsDataURL(file);

        if (file.size < 1000) {
          this.toast.showWarningToast('votre signature est trop petite, veuillez recommencer');
        } else {

          const config: any = {
            responseType: 'arraybuffer' as 'arraybuffer',
            observe: 'response'
          };
          const formData: FormData = new FormData();

          formData.append('file', file, file.name);
          formData.append('mode', 'SAVE');
          formData.append('token', this.indParam.AppParams.token);
          formData.append('saveMode', this.mode);
          const model: SignatureModel = new SignatureModel();
          model.strIdDonneeFils = this.idFils;
          model.strIdDonneePere = this.idPere;
          model.strNomRelation = this.nomRel;
          model.updateIsAuthorized = this.isEditable;
          model.Mode = `SAVE_${this.mode}`;
          formData.append('model', JSON.stringify(model));
          let result: Observable<any>;
          switch (this.indParam.Context) {
            case eAppContext.QUEOVAL:
              result = this.http.post(`${this.indParam.AppParams.apiUrl}api/signatureStreamQueoval/`, formData, config);
              break;
            default:
              result = this.http.post(`${this.indParam.AppParams.apiUrl}api/signatureStreamExtranet/`, formData, config);
              break;
          }
          this.loaded = false;
          result.subscribe(
            (result: any) => {
              this.loaded = true;
              const res: SignatureModel = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(result.body)));
              this.preview = res.strPath ? `${res.strPath}?${Date.now()}` : null;
              this.fileExistEmitter.emit(!!this.preview);
              setAlertMNG(this.indParam, this.router, this.toast, res);

            });
        }
      }
   // }
  }
  


}
